import axios from 'axios';
import { decryptToken } from '../utils/tokenUtils';

const baseURL = process.env.REACT_APP_BACKEND_URL;

const axiosInstance = axios.create({
  baseURL: baseURL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      try {
        // Decrypt the token before sending
        const decryptedToken = decryptToken(token.replace(/^encrypted:/, ''));
        if (decryptedToken) {
          config.headers.Authorization = `Bearer ${decryptedToken}`;
        } else {
          console.error("Failed to decrypt token");
        }
      } catch (error) {
        console.error("Error decrypting token", error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Uncomment later

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response && error.response.status === 401) {
        localStorage.setItem('authenticated', 'false');
        localStorage.removeItem('authToken');
        window.location.href = `${process.env.PUBLIC_URL}/auth/login`;
    }
    return Promise.reject(error);
  }
);


export default axiosInstance;
